import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Table, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import InputField from "../../../components/input/input-field";
import CustomPhoneInput from "../../../components/input/phone-input";
import "react-phone-input-2/lib/style.css";
import Select, { components } from "react-select";
import FadeLoaderComponent from "../../../components/loader-component";
import { RxCross2 } from "react-icons/rx";
import { FaPlus } from "react-icons/fa";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import { roleTypes } from "../../../data/roleType";
import DatePickerField from "../../../components/input/date-picker-field";

const CustomMenuList = ({ children, ...props }) => {
  const { selectProps } = props;
  const {
    isAddingNewType,
    setIsAddingNewType,
    setIsAddingNewContact,
    newTypeName,
    setNewTypeName,
    newTypeError,
    setNewTypeError,
    newTypeInputRef,
    isSubmittingNewType,
    handleSubmitNewType,
    handleCancelNewType,
    setOpenContactMenuIndex,
    setOpenSystemMenuIndex,
  } = selectProps;

  return (
    <components.MenuList {...props}>
      {!isAddingNewType ? (
        <>
          {children}
          <div
            style={{
              padding: "10px 12px",
              cursor: "pointer",
              backgroundColor: "#f8f9fa",
              borderTop: "1px solid #dee2e6",
              color: "#007bff",
              fontWeight: "500",
              textAlign: "center",
              transition: "background-color 0.2s",
              position: "sticky",
              bottom: -4,
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsAddingNewContact(false);
              setOpenContactMenuIndex(null);
              setOpenSystemMenuIndex(null);
              setIsAddingNewType(true);
              setNewTypeName("");
              setNewTypeError("");
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#e9ecef";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f8f9fa";
            }}
          >
            + Add New Type
          </div>
        </>
      ) : (
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderTop: "1px solid #dee2e6",
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{
              marginBottom: "8px",
              fontSize: "13px",
              fontWeight: "600",
              color: "#495057",
            }}
          >
            Create New Type
          </div>
          <div style={{ display: "flex", gap: "6px", alignItems: "start" }}>
            <div style={{ flex: 1 }}>
              <input
                ref={newTypeInputRef}
                type="text"
                placeholder="Enter type name"
                value={newTypeName}
                onChange={(e) => {
                  setNewTypeName(e.target.value);
                  setNewTypeError("");
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmitNewType();
                  } else if (e.key === "Escape") {
                    e.preventDefault();
                    handleCancelNewType();
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewType}
                autoFocus
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: newTypeError
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => {
                  if (!newTypeError) {
                    e.target.style.borderColor = "#007bff";
                  }
                }}
                onBlur={(e) => {
                  if (!newTypeError) {
                    e.target.style.borderColor = "#ced4da";
                  }
                }}
              />
              {newTypeError && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "6px",
                  }}
                >
                  {newTypeError}
                </div>
              )}
            </div>
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSubmitNewType();
              }}
              disabled={isSubmittingNewType}
              style={{
                padding: "6px 12px",
                backgroundColor: isSubmittingNewType ? "#0d67c8ff" : "#28a745",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewType ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#218838";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#28a745";
                }
              }}
            >
              {isSubmittingNewType ? "..." : "✓"}
            </button>
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCancelNewType();
              }}
              className="bg-danger"
              disabled={isSubmittingNewType}
              style={{
                padding: "6px 12px",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewType ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#5a6268";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#6c757d";
                }
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </components.MenuList>
  );
};

const CustomContactMenuList = ({ children, ...props }) => {
  const { selectProps } = props;
  const {
    isAddingNewContact,
    setIsAddingNewContact,
    setIsAddingNewType,
    newContactData,
    setNewContactData,
    newContactError,
    setNewContactError,
    isSubmittingNewContact,
    handleSubmitNewContact,
    handleCancelNewContact,
    hasCreateStakeholderPermission,
    isSuperAdmin,
    displayButton,
    setOpenTypeMenuIndex,
    setOpenSystemMenuIndex,
  } = selectProps;
  const canAddContact = hasCreateStakeholderPermission || isSuperAdmin;

  return (
    <components.MenuList {...props}>
      {!isAddingNewContact ? (
        <>
          {children}
          {canAddContact && displayButton && (
            <div
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #dee2e6",
                color: "#007bff",
                fontWeight: "500",
                textAlign: "center",
                transition: "background-color 0.2s",
                position: "sticky",
                bottom: -4,
                zIndex: 1,
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsAddingNewType(false);
                setOpenTypeMenuIndex(null);
                setOpenSystemMenuIndex(null);
                setIsAddingNewContact(true);
                setNewContactData({
                  name: "",
                  phone_number: "",
                  email: "",
                  title: "",
                });
                setNewContactError("");
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
              }}
            >
              + Add New Contact
            </div>
          )}
        </>
      ) : (
        displayButton && (
          <div
            style={{
              padding: "12px",
              backgroundColor: "#fff",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <div
              style={{
                marginBottom: "8px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#495057",
              }}
            >
              Create New Contact
            </div>
            <Form.Group className="form-group mb-1">
              <Form.Label style={{ fontSize: "14px", fontWeight: "600" }}>
                Contact Name
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={newContactData.name}
                onChange={(e) => {
                  setNewContactData({
                    ...newContactData,
                    name: e.target.value,
                  });
                  setNewContactError("");
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewContact}
                autoFocus
                style={{
                  fontSize: "14px",
                }}
              />
            </Form.Group>
            <Form.Group className="form-group mb-1">
              <Form.Label
                htmlFor="newContactPhone"
                style={{ fontSize: "14px", fontWeight: "600" }}
              >
                Phone Number
                <span className="text-danger">*</span>
              </Form.Label>
              <div
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              >
                <CustomPhoneInput
                  id="newContactPhone"
                  name="newContactPhone"
                  value={newContactData.phone_number}
                  onChange={(value) => {
                    setNewContactData({
                      ...newContactData,
                      phone_number: value,
                    });
                    setNewContactError("");
                  }}
                  disabled={isSubmittingNewContact}
                  placeholder="Enter phone number"
                  country="us"
                />
              </div>
            </Form.Group>
            {newContactError && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "12px",
                  marginTop: "6px",
                }}
              >
                {newContactError}
              </div>
            )}

            <div
              style={{
                display: "flex",
                gap: "6px",
                justifyContent: "flex-end",
                marginTop: "4px",
              }}
            >
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleSubmitNewContact();
                }}
                disabled={isSubmittingNewContact}
                style={{
                  padding: "6px 12px",
                  backgroundColor: isSubmittingNewContact
                    ? "#0d67c8ff"
                    : "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: isSubmittingNewContact ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                  minWidth: "36px",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#218838";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#28a745";
                  }
                }}
              >
                {isSubmittingNewContact ? "..." : "✓"}
              </button>
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleCancelNewContact();
                }}
                className="bg-danger"
                disabled={isSubmittingNewContact}
                style={{
                  padding: "6px 12px",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: isSubmittingNewContact ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                  minWidth: "36px",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#5a6268";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#6c757d";
                  }
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )
      )}
    </components.MenuList>
  );
};

const CustomSystemMenuList = ({ children, ...props }) => {
  const { selectProps } = props;
  const {
    isAddingNewSystem,
    setIsAddingNewSystem,
    setIsAddingNewContact,
    setIsAddingNewType,
    newSystemData,
    setNewSystemData,
    newSystemError,
    setNewSystemError,
    isSubmittingNewSystem,
    handleSubmitNewSystem,
    handleCancelNewSystem,
    hasCreateSystemPermission,
    hasCreatePhasePermission,
    isSuperAdmin,
    setOpenTypeMenuIndex,
    setOpenContactMenuIndex,
  } = selectProps;
  const canAddSystem =
    hasCreateSystemPermission || hasCreatePhasePermission || isSuperAdmin;

  return (
    <components.MenuList {...props}>
      {!isAddingNewSystem ? (
        <>
          {children}
          {canAddSystem && (
            <div
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #dee2e6",
                color: "#007bff",
                fontWeight: "500",
                textAlign: "center",
                transition: "background-color 0.2s",
                position: "sticky",
                bottom: -4,
                zIndex: 1,
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsAddingNewContact(false);
                setIsAddingNewType(false);
                setOpenTypeMenuIndex(null);
                setOpenContactMenuIndex(null);
                setIsAddingNewSystem(true);
                setNewSystemData({ name: "", phases: "" });
                setNewSystemError("");
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
              }}
            >
              + Add New System
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderTop: "1px solid #dee2e6",
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{
              marginBottom: "8px",
              fontSize: "13px",
              fontWeight: "600",
              color: "#495057",
            }}
          >
            Create New System
          </div>
          <div style={{ marginBottom: "8px" }}>
            <Form.Group className="form-group mb-1">
              <Form.Label
                htmlFor="newSystemName"
                style={{ fontSize: "14px", fontWeight: "600" }}
              >
                System Name
                <span className="text-danger">*</span>
              </Form.Label>
              <input
                type="text"
                id="newSystemName"
                name="newSystemName"
                placeholder="Enter system name"
                value={newSystemData.name}
                onChange={(e) => {
                  setNewSystemData({ ...newSystemData, name: e.target.value });
                  setNewSystemError("");
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmitNewSystem();
                  } else if (e.key === "Escape") {
                    e.preventDefault();
                    handleCancelNewSystem();
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewSystem}
                autoFocus
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: newSystemError
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => {
                  if (!newSystemError) {
                    e.target.style.borderColor = "#007bff";
                  }
                }}
                onBlur={(e) => {
                  if (!newSystemError) {
                    e.target.style.borderColor = "#ced4da";
                  }
                }}
              />
            </Form.Group>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <Form.Group className="form-group mb-1">
              <Form.Label
                htmlFor="newSystemPhases"
                style={{ fontSize: "14px", fontWeight: "600" }}
              >
                Phases (comma-separated)
                <span className="text-danger">*</span>
              </Form.Label>
              <textarea
                rows={2}
                id="newSystemPhases"
                name="newSystemPhases"
                className="form-control"
                value={newSystemData.phases}
                onChange={(e) => {
                  setNewSystemData({
                    ...newSystemData,
                    phases: e.target.value,
                  });
                  setNewSystemError("");
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Escape") {
                    e.preventDefault();
                    handleCancelNewSystem();
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewSystem}
                placeholder="e.g. Phase 1, Phase 2, Phase 3"
                style={{
                  fontSize: "14px",
                  resize: "none",
                }}
              />
            </Form.Group>
          </div>
          {newSystemError && (
            <div
              style={{
                color: "#dc3545",
                fontSize: "12px",
                marginBottom: "8px",
              }}
            >
              {newSystemError}
            </div>
          )}
          <div
            style={{ display: "flex", gap: "6px", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSubmitNewSystem();
              }}
              className="bg-success"
              disabled={isSubmittingNewSystem}
              style={{
                padding: "6px 12px",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewSystem ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#218838";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#28a745";
                }
              }}
            >
              {isSubmittingNewSystem ? "..." : "✓"}
            </button>
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCancelNewSystem();
              }}
              className="bg-danger"
              disabled={isSubmittingNewSystem}
              style={{
                padding: "6px 12px",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewSystem ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#5a6268";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#6c757d";
                }
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </components.MenuList>
  );
};

const JobAdd = () => {
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [errors, setErrors] = useState({});
  const [decodedToken, setDecodedToken] = useState();
  const [contacts, setContacts] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [systems, setSystems] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [stakeholderTypeOptions, setStakeholderTypeOptions] = useState([]);
  const [isAddingNewType, setIsAddingNewType] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const [newTypeError, setNewTypeError] = useState("");
  const [isSubmittingNewType, setIsSubmittingNewType] = useState(false);
  const [systemPhasesMap, setSystemPhasesMap] = useState({});
  const token = localStorage.getItem("coyote-token");
  const newTypeInputRef = useRef(null);
  const [openTypeMenuIndex, setOpenTypeMenuIndex] = useState(null);
  const [contactsLoadingMap, setContactsLoadingMap] = useState({});

  const [isAddingNewContact, setIsAddingNewContact] = useState(false);
  const [newContactData, setNewContactData] = useState({
    name: "",
    phone_number: "",
  });
  const [newContactError, setNewContactError] = useState("");
  const [isSubmittingNewContact, setIsSubmittingNewContact] = useState(false);
  const [openContactMenuIndex, setOpenContactMenuIndex] = useState(null);

  const [isAddingNewSystem, setIsAddingNewSystem] = useState(false);
  const [newSystemData, setNewSystemData] = useState({ name: "", phases: "" });
  const [newSystemError, setNewSystemError] = useState("");
  const [isSubmittingNewSystem, setIsSubmittingNewSystem] = useState(false);
  const [openSystemMenuIndex, setOpenSystemMenuIndex] = useState(null);
  const permissions = useSelector(SettingSelector.set_permissions);
  const hasCreateStakeholderPermission =
    permissions?.stakeholder?.update === true;
  const hasCreateSystemPermission = permissions?.system?.create === true;
  const hasCreatePhasePermission = permissions?.phase?.create === true;
  const isSuperAdmin = decodedToken?.roles?.some(
    (role) => role.role_type === roleTypes.SUPER_ADMIN
  );
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    estimate: null,
    bidDate: (function () {
      const today = new Date();
      return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(today.getDate()).padStart(2, "0")}`;
    })(),
    siteName: "",
    contacts: [
      {
        stakeholderId: null,
        contactId: null,
        type: "",
      },
    ],
    systems: [
      {
        systemId: null,
        phases: [],
      },
    ],
    activeSystemId: null,
    activePhaseId: null,
    area: [""],
  });
  const [selectKey, setSelectKey] = useState(0);

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getSystems = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(`${url.backendURL}system/all`, config);
      setSystems(response.data.response.data);
    } catch (err) {
      handleError(err, "job-add");
    }
  };

  const getStakeholders = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}stakeholder/all`,
        config
      );
      setStakeholders(response.data.response.data);
    } catch (err) {
      handleError(err, "job-add");
    }
  };

  const getContacts = async (stakeholder, index) => {
    setContactsLoadingMap((prev) => ({ ...prev, [index]: true }));
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}stakeholder/${stakeholder}/contacts`,
        config
      );
      const contactsData = response.data.response.data || [];
      setAllContacts((prev) => ({
        ...prev,
        [stakeholder]: contactsData,
      }));
      setContacts(contactsData);
      return contactsData;
    } catch (err) {
      return [];
    } finally {
      setContactsLoadingMap((prev) => {
        const newMap = { ...prev };
        delete newMap[index];
        return newMap;
      });
    }
  };

  const fetchStakeholderTypes = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const res = await axios.get(`${url.backendURL}stakeholder/types`, config);
      const types = res.data.response.data || [];
      setStakeholderTypeOptions(
        types.map((t) => ({ value: t.name, label: t.name }))
      );
    } catch (err) { }
  };

  const getAvailableTypeOptions = (stakeholderId, currentIndex, values) => {
    if (!stakeholderId) return stakeholderTypeOptions;
    const normalize = (val) =>
      val === undefined || val === null ? "" : String(val).trim();

    const usedTypes = values.contacts
      .map((contact, idx) =>
        idx !== currentIndex && contact.stakeholderId === stakeholderId
          ? normalize(contact.type)
          : null
      )
      .filter((type) => type && type !== "");
    return stakeholderTypeOptions.filter(
      (option) => !usedTypes.includes(normalize(option.value))
    );
  };

  const createStakeholderType = async (name) => {
    setIsSubmittingNewType(true);
    try {
      const config = { headers: { Authorization: `${token}` } };
      await axios.post(`${url.backendURL}stakeholder/types`, { name }, config);
      setStakeholderTypeOptions((prev) => [
        ...prev,
        { value: name, label: name },
      ]);
      setNewTypeName("");
      setNewTypeError("");
      return { success: true };
    } catch (err) {
      if (err?.response?.status === 409) {
        await fetchStakeholderTypes();
        setNewTypeError(
          err?.response?.data?.message || "Stakeholder type already exists"
        );
        return { success: false };
      }
      setNewTypeError(err?.response?.data?.message || "Failed to create type");
      return { success: false };
    } finally {
      setIsSubmittingNewType(false);
    }
  };

  const handleSubmitNewType = async (setFieldValue, fieldName) => {
    const name = newTypeName.trim();
    if (!name) {
      setNewTypeError("Type name is required");
      return;
    }
    const res = await createStakeholderType(name);
    if (res.success) {
      setIsAddingNewType(false);
      if (typeof setFieldValue === "function" && fieldName) {
        setFieldValue(fieldName, name);
      }
      setOpenTypeMenuIndex(null);
    }
  };

  const handleCancelNewType = () => {
    setIsAddingNewType(false);
    setNewTypeName("");
    setNewTypeError("");
    setOpenTypeMenuIndex(null);
  };

  useEffect(() => {
    fetchStakeholderTypes();
  }, []);

  const createContact = async (stakeholderId, contactData) => {
    setIsSubmittingNewContact(true);
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.post(
        `${url.backendURL}stakeholder/${stakeholderId}/contacts`,
        contactData,
        config
      );

      const newContact = response.data.response.data;

      setAllContacts((prev) => {
        const existingContacts = prev[stakeholderId] || [];
        return {
          ...prev,
          [stakeholderId]: [...existingContacts, newContact],
        };
      });

      setContacts((prev) => [...prev, newContact]);

      return { success: true, data: newContact };
    } catch (err) {
      setNewContactError(
        err?.response?.data?.message || "Failed to create contact"
      );
      return { success: false };
    } finally {
      setIsSubmittingNewContact(false);
    }
  };

  const handleSubmitNewContact = async (
    setFieldValue,
    index,
    stakeholderId
  ) => {
    if (!newContactData.name || !newContactData.name.trim()) {
      setNewContactError("Name is required");
      return;
    }
    const nameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 '&.-]*$/;
    if (!nameRegex.test(newContactData.name)) {
      setNewContactError("Invalid name format");
      return;
    }

    if (!newContactData.phone_number || !newContactData.phone_number.trim()) {
      setNewContactError("Phone number is required");
      return;
    }
    if (newContactData.phone_number.length < 10) {
      setNewContactError("Phone number must be at least 10 digits");
      return;
    }

    if (!stakeholderId) {
      setNewContactError("Stakeholder not selected");
      return;
    }

    const res = await createContact(stakeholderId, newContactData);
    if (res.success && res.data) {
      setIsAddingNewContact(false);
      setNewContactData({ name: "", phone_number: "" });
      setNewContactError("");
      setOpenContactMenuIndex(null);
      if (typeof setFieldValue === "function") {
        setFieldValue(`contacts.${index}.contactId`, res.data.id);
      }
    }
  };

  const handleCancelNewContact = () => {
    setIsAddingNewContact(false);
    setNewContactData({ name: "", phone_number: "" });
    setNewContactError("");
    setOpenContactMenuIndex(null);
  };

  const handleCancelNewSystem = () => {
    setIsAddingNewSystem(false);
    setNewSystemData({ name: "", phases: "" });
    setNewSystemError("");
    setOpenSystemMenuIndex(null);
  };

  const createSystemWithPhases = async (systemData) => {
    setIsSubmittingNewSystem(true);
    try {
      const config = { headers: { Authorization: `${token}` } };

      const phasesArray = systemData.phases
        ? systemData.phases
          .split(",")
          .map((phase) => phase.trim())
          .filter((phase) => phase.length > 0)
          .map((phase) => ({ name: phase }))
        : [];

      const response = await axios.post(
        `${url.backendURL}system/phases`,
        {
          name: systemData.name,
          phases: phasesArray,
        },
        config
      );
      return { success: true, data: response.data.response.data };
    } catch (err) {
      if (err?.response?.status === 409) {
        setNewSystemError(
          err?.response?.data?.message || "System with this name already exists"
        );
        return { success: false, error: "exists" };
      }
      setNewSystemError(
        err?.response?.data?.message || "Failed to create system with phases"
      );
      return { success: false };
    } finally {
      setIsSubmittingNewSystem(false);
    }
  };

  const handleSubmitNewSystem = async (setFieldValue, index, currentValues) => {
    if (!newSystemData.name || !newSystemData.name.trim()) {
      setNewSystemError("System name is required");
      return;
    }
    if (!newSystemData.phases || !newSystemData.phases.trim()) {
      setNewSystemError("At least one phase is required");
      return;
    }

    setNewSystemError("");
    const result = await createSystemWithPhases(newSystemData);

    if (result.success && result.data) {
      const systemId = result.data.system.id;
      const allPhases = [
        ...result.data.phases.created,
        ...result.data.phases.existing,
      ];

      await getSystems();

      const fetchedPhases = await getPhases(systemId, index);
      setSystemPhasesMap((prev) => ({
        ...prev,
        [systemId]: fetchedPhases,
      }));

      setIsAddingNewSystem(false);
      setNewSystemData({ name: "", phases: "" });
      setOpenSystemMenuIndex(null);

      if (typeof setFieldValue === "function") {
        setFieldValue(`systems.${index}.systemId`, systemId);
        const phaseIds = fetchedPhases.map((p) => p.id);
        setFieldValue(`systems.${index}.phases`, phaseIds);

        setTimeout(() => {
          if (index === 0 || !currentValues.activeSystemId) {
            setFieldValue("activeSystemId", systemId);
            setFieldValue("activePhaseId", phaseIds[0] || null);
          }
        }, 0);
      }
    }
  };
  useEffect(() => {
    if (isAddingNewType && newTypeInputRef.current) {
      setTimeout(() => {
        newTypeInputRef.current?.focus();
      }, 100);
    }
  }, [isAddingNewType]);

  const [isSubmitSystem, setIsSubmitSystem] = useState({});
  const getPhases = async (productSystemId, systemIndex = null) => {
    try {
      if (systemIndex !== null) {
        setIsSubmitSystem((prev) => ({ ...prev, [systemIndex]: true }));
      }
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}product/system/${productSystemId}/phase`,
        config
      );
      if (systemIndex !== null) {
        setIsSubmitSystem((prev) => ({ ...prev, [systemIndex]: false }));
      }
      return response.data.response.data;
    } catch (err) {
      if (systemIndex !== null) {
        setIsSubmitSystem((prev) => ({ ...prev, [systemIndex]: false }));
      }
      handleError(err, "job-add");
      return [];
    }
  };

  useEffect(() => {
    if (token && decodedToken) {
      const fetchData = async () => {
        await getSystems();
        await getStakeholders();
        setLoader(false);
      };
      fetchData();
    }
  }, [token, decodedToken]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const formattedSystems = values.systems.map((sys) => ({
        systemId: sys.systemId,
        phaseIds: sys.phases,
      }));

      const filteredAreas = values.area
        .map((area) => area.trim())
        .filter((area) => area.length > 0);

      const submitData = {
        ...values,
        systems: formattedSystems,
        area: filteredAreas,
      };

      const response = await axios.post(
        `${url.backendURL}job/`,
        submitData,
        config
      );

      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      setAlert({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "job-add",
      });
      setErrors({});
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
        navigate(`/dashboard/app/job-list`);
      }, 2000);
    } catch (err) {
      handleError(err, "job-add");
    } finally {
      setSubmitting(false);
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (
      response.data.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const validationSchema = () =>
    Yup.object().shape({
      name: Yup.string()
        .trim()
        .min(2, "Project name must be at least 2 characters long")
        .max(70, "Project name must not exceed 70 characters")
        .test(
          "starts-with-letter",
          "Project name must start with a letter",
          (value) => {
            if (!value) return false;
            return /^[a-zA-Z]/.test(value);
          }
        )
        .required("Project name is required"),
      location: Yup.string()
        .matches(
          /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
          "Address must contain at least one letter or number"
        )
        .min(2, "Address must be at least 2 characters long")
        .max(255, "Address must not exceed 255 characters")
        .trim()
        .nullable()
        .notRequired(),
      estimate: Yup.number()
        .nullable()
        .transform((value, originalValue) => {
          const trimmed = String(originalValue ?? "").trim();

          if (trimmed === "") return null;
          let formatted = trimmed;
          if (formatted.startsWith(".")) formatted = "0" + formatted;
          if (formatted.endsWith(".")) formatted = formatted.slice(0, -1);

          const num = Number(formatted);
          if (isNaN(num)) return null;
          return Math.round(num * 100) / 100;
        })
        .typeError("Estimate must be a number")
        .min(0, "Estimate must be positive")
        .test(
          "max-digits",
          "Estimate must have a maximum of 2 decimal places",
          (value) => {
            if (value === null || value === undefined) return true;
            return /^\d{1,12}(\.\d{1,2})?$/.test(value.toString());
          }
        )
        .notRequired(),

      bidDate: Yup.date()
        .required("Start date is required")
        .typeError("Start date must be a valid date")
        .min(
          new Date().toISOString().slice(0, 10),
          "Start date cannot be in the past"
        ),
      siteName: Yup.string()
        .trim()
        .matches(/^[^\d]/, "Site name must not start with a number")
        .min(2, "Site name must be at least 2 character long")
        .max(255, "Site name must not exceed 255 characters")
        .required("Site name is required"),
      contacts: Yup.array()
        .of(
          Yup.object().shape({
            stakeholderId: Yup.number()
              .integer("Stakeholder is required")
              .typeError("Stakeholder is invalid")
              .required("Stakeholder is required"),
            contactId: Yup.number()
              .nullable()
              .optional()
              .integer("Contact must be valid")
              .typeError("Contact is invalid"),
            type: Yup.string().trim().required("Type is required"),
          })
        )
        .min(1, "At least one stakeholder is required")
        .required("Stakeholders are required")
        .test(
          "unique-contacts",
          "Duplicate stakeholder, type, and contact combination not allowed",
          function (value) {
            if (!value) return true;
            const combinations = value.map(
              (v) =>
                `${v.stakeholderId || ""}-${v.type || ""}-${v.contactId || "null"
                }`
            );
            const unique = new Set(combinations);
            if (unique.size < combinations.length) {
              return this.createError({
                message:
                  "Duplicate stakeholder, type, and contact combination not allowed",
              });
            }
            return true;
          }
        ),
      systems: Yup.array()
        .of(
          Yup.object().shape({
            systemId: Yup.number()
              .integer()
              .required("System is required")
              .typeError("System must be valid"),
            phases: Yup.array()
              .of(Yup.number().integer().required("Phase must be valid"))
              .min(1, "At least one phase is required")
              .required("Phases are required"),
          })
        )
        .min(1, "At least one system is required")
        .required("Systems are required"),
      activeSystemId: Yup.number()
        .integer()
        .required("Active system is required")
        .test(
          "is-in-systems",
          "Active system must be one of the selected systems",
          function (value) {
            const { systems } = this.parent;
            return systems?.some((sys) => sys.systemId === value);
          }
        ),
      activePhaseId: Yup.number()
        .integer()
        .required("Active phase is required")
        .test(
          "is-in-active-system-phases",
          "Active phase must belong to the selected system",
          function (value) {
            const { systems, activeSystemId } = this.parent;
            const activeSystem = systems?.find(
              (sys) => sys.systemId === activeSystemId
            );
            return activeSystem?.phases?.includes(value);
          }
        ),
      area: Yup.array()
        .of(
          Yup.string()
            .trim()
            .test(
              "not-only-numbers",
              "Area cannot be only numbers",
              (value) => {
                if (!value) return true;
                return !/^\d+$/.test(value);
              }
            )
        )
        .optional(),
    });

  const [optionsSystem, setOptionsSystem] = useState([]);

  useEffect(() => {
    const systemOptions =
      systems.length > 0 &&
      systems.map((system) => ({
        value: system.id,
        label: system.name,
      }));
    setOptionsSystem(systemOptions || []);
  }, [systems]);

  const [optionsStakeholder, setOptionsStakeholder] = useState([]);

  useEffect(() => {
    if (stakeholders.length > 0) {
      const flatOptions = [];
      stakeholders.forEach((group) => {
        if (group.stakeholders) {
          group.stakeholders.forEach((stakeholder) => {
            flatOptions.push({
              value: stakeholder.id,
              label: stakeholder.name,
              type: group.type,
            });
          });
        }
      });
      setOptionsStakeholder(flatOptions);
    }
  }, [stakeholders]);

  const [allContacts, setAllContacts] = useState({});

  const getContactOptionsForStakeholder = (stakeholderId) => {
    const stakeholderContacts = allContacts[stakeholderId] || [];
    return stakeholderContacts.map((contact) => ({
      value: contact.id,
      label: contact.name,
      email: contact.email,
      phone: contact.phone_number,
    }));
  };

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#007bff" : "#dee2e6",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#007bff",
      },
      minHeight: "38px",
      backgroundColor: "#fff",
    }),
  };

  const getAvailableSystemOptions = (selectedSystems, currentIndex) => {
    const selectedSystemIds = selectedSystems
      .map((sys, idx) => (idx !== currentIndex ? sys.systemId : null))
      .filter((id) => id !== null);

    return systems
      .filter((system) => !selectedSystemIds.includes(system.id))
      .map((system) => ({
        value: system.id,
        label: system.name,
      }));
  };

  const getActiveSystemOptions = (selectedSystems) => {
    return selectedSystems
      .filter((sys) => sys.systemId !== null)
      .map((sys) => {
        const systemData = systems.find((s) => s.id === sys.systemId);
        return {
          value: sys.systemId,
          label: systemData?.name || `System ${sys.systemId}`,
        };
      });
  };

  const getActivePhaseOptions = (selectedSystems, activeSystemId) => {
    if (!activeSystemId) return [];
    const activeSystem = selectedSystems.find(
      (sys) => sys.systemId === activeSystemId
    );
    if (!activeSystem || !systemPhasesMap[activeSystemId]) return [];

    return systemPhasesMap[activeSystemId]
      .filter((phase) => activeSystem.phases.includes(phase.id))
      .map((phase) => ({
        value: phase.id,
        label: phase.name,
      }));
  };

  const areAllSystemsSelected = (selectedSystems) => {
    const selectedSystemIds = selectedSystems
      .map((sys) => sys.systemId)
      .filter((id) => id !== null);
    return selectedSystemIds.length >= systems.length;
  };

  return (
    <>
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            ...formData,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            touched,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            resetForm,
            errors: errorsFormik,
          }) => (
            <Form onSubmit={handleSubmit}>
              <FocusError />
              <Row>
                <Col xl="12" lg="12" ref={alertRef}>
                  <Card>
                    <Card.Header className="d-flex justify-content-between">
                      <div
                        className="breadcrumb header-title"
                        style={{ cursor: "pointer" }}
                      >
                        <h4
                          onClick={() => navigate("/dashboard/app/job-list")}
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Job</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title">Add</h4>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <AlertNotificationSimple
                        type={alert.type}
                        message={alert.message}
                        show={alert.show}
                        onClose={() => setAlert({ ...alert, show: false })}
                      />
                      {!loader ? (
                        <>
                          <Row>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="name"
                                placeholder="Enter project name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.name}
                                label="Project Name"
                              />
                            </Col>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="location"
                                placeholder="Enter address"
                                value={values.location}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                errorMessage={errors?.location}
                                label="Address"
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="estimate"
                                placeholder="Enter estimate"
                                value={values.estimate}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (
                                    /^\d{0,12}(\.\d{0,2})?$/.test(value) ||
                                    value === ""
                                  ) {
                                    setFieldValue("estimate", value);
                                  }
                                }}
                                onBlur={(e) => {
                                  let value = e.target.value.trim();
                                  if (value === "") return;
                                  if (value.startsWith("."))
                                    value = "0" + value;
                                  if (value.endsWith("."))
                                    value = value.slice(0, -1);
                                  if (!isNaN(value)) {
                                    const [intPart, decPart] = value.split(".");
                                    if (intPart.length > 12) {
                                      value =
                                        intPart.slice(0, 12) +
                                        (decPart
                                          ? "." + decPart.slice(0, 2)
                                          : "");
                                    } else if (decPart) {
                                      value = `${intPart}.${decPart.slice(
                                        0,
                                        2
                                      )}`;
                                    }
                                  }

                                  setFieldValue("estimate", value);
                                }}
                                errorMessage={errors?.estimate}
                                label="Estimate"
                                step="0.01"
                                pattern="^\d{1,12}(\.\d{1,2})?$"
                                min={0}
                              />
                            </Col>
                            <Col md={6}>
                              <DatePickerField
                                className="col-md-12 form-group"
                                name="bidDate"
                                placeholder="Enter start date"
                                value={values.bidDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.bidDate}
                                label="Start Date"
                                minDate={new Date()}
                                dateFormat="MM/dd/yyyy"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="siteName"
                                placeholder="Enter site name"
                                value={values.siteName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.siteName}
                                label="Site Name"
                              />
                            </Col>
                          </Row>

                          <Row className="mb-3 mt-4">
                            <Col md={12}>
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="text-primary mb-0">
                                  Systems & Phases
                                </h5>
                              </div>
                            </Col>
                          </Row>
                          <Card className="p-2 p-md-4 border rounded">
                            <FieldArray name="systems">
                              {({ push, remove }) => (
                                <>
                                  {values.systems.map((system, index) => {
                                    const phases =
                                      system.systemId &&
                                        systemPhasesMap[system.systemId]
                                        ? systemPhasesMap[system.systemId]
                                        : [];
                                    const availableOptions =
                                      getAvailableSystemOptions(
                                        values.systems,
                                        index
                                      );

                                    return (
                                      <div key={index} className="mb-4 p-3">
                                        <Row>
                                          <Col md={6}>
                                            <Form.Group className="form-group">
                                              <Form.Label>
                                                System
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </Form.Label>
                                              <Select
                                                closeMenuOnScroll={(e) => {
                                                  try {
                                                    const target = e.target;

                                                    if (
                                                      !target ||
                                                      !target.nodeType ||
                                                      typeof target.closest !==
                                                        "function"
                                                    ) {
                                                      return true;
                                                    }

                                                    const isMenuScroll =
                                                      target.closest(
                                                        '[class*="MenuList"]'
                                                      ) ||
                                                      target.closest(
                                                        '[class*="menu"]'
                                                      );

                                                    return !isMenuScroll;
                                                  } catch (error) {
                                                    return true;
                                                  }
                                                }}
                                                options={availableOptions}
                                                name={`systems.${index}.systemId`}
                                                value={
                                                  system.systemId
                                                    ? availableOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          system.systemId
                                                      ) ||
                                                      systems
                                                        .filter(
                                                          (s) =>
                                                            s.id ===
                                                            system.systemId
                                                        )
                                                        .map((s) => ({
                                                          value: s.id,
                                                          label: s.name,
                                                        }))[0]
                                                    : null
                                                }
                                                onChange={async (option) => {
                                                  const newSystemId =
                                                    option?.value || null;
                                                  const oldSystemId =
                                                    system.systemId;
                                                  setFieldValue(
                                                    `systems.${index}.systemId`,
                                                    newSystemId
                                                  );

                                                  if (newSystemId) {
                                                    const fetchedPhases =
                                                      await getPhases(
                                                        newSystemId,
                                                        index
                                                      );
                                                    setSystemPhasesMap(
                                                      (prev) => ({
                                                        ...prev,
                                                        [newSystemId]:
                                                          fetchedPhases,
                                                      })
                                                    );

                                                    const allPhaseIds =
                                                      fetchedPhases.map(
                                                        (phase) => phase.id
                                                      );
                                                    setFieldValue(
                                                      `systems.${index}.phases`,
                                                      allPhaseIds
                                                    );

                                                    if (
                                                      index === 0 &&
                                                      !values.activeSystemId
                                                    ) {
                                                      const defaultPhaseId =
                                                        fetchedPhases?.[0]
                                                          ?.id || null;
                                                      setFieldValue(
                                                        "activeSystemId",
                                                        newSystemId
                                                      );
                                                      setFieldValue(
                                                        "activePhaseId",
                                                        defaultPhaseId
                                                      );
                                                    } else if (
                                                      oldSystemId ===
                                                      values.activeSystemId
                                                    ) {
                                                      const defaultPhaseId =
                                                        fetchedPhases?.[0]
                                                          ?.id || null;
                                                      setFieldValue(
                                                        "activeSystemId",
                                                        newSystemId
                                                      );
                                                      setFieldValue(
                                                        "activePhaseId",
                                                        defaultPhaseId
                                                      );
                                                    }
                                                  } else {
                                                    setFieldValue(
                                                      `systems.${index}.phases`,
                                                      []
                                                    );

                                                    if (
                                                      oldSystemId ===
                                                      values.activeSystemId
                                                    ) {
                                                      setTimeout(() => {
                                                        const updatedSystems =
                                                          values.systems.map(
                                                            (sys, idx) =>
                                                              idx === index
                                                                ? {
                                                                  ...sys,
                                                                  systemId:
                                                                    null,
                                                                  phases: [],
                                                                }
                                                                : sys
                                                          );

                                                        const firstValidSystem =
                                                          updatedSystems.find(
                                                            (sys) =>
                                                              sys.systemId !==
                                                              null
                                                          );

                                                        if (firstValidSystem) {
                                                          const firstSystemPhases =
                                                            systemPhasesMap[
                                                            firstValidSystem
                                                              .systemId
                                                            ] || [];
                                                          setFieldValue(
                                                            "activeSystemId",
                                                            firstValidSystem.systemId
                                                          );
                                                          setFieldValue(
                                                            "activePhaseId",
                                                            firstSystemPhases?.[0]
                                                              ?.id || null
                                                          );
                                                        } else {
                                                          setFieldValue(
                                                            "activeSystemId",
                                                            null
                                                          );
                                                          setFieldValue(
                                                            "activePhaseId",
                                                            null
                                                          );
                                                        }
                                                      }, 0);
                                                    }
                                                  }
                                                }}
                                                onMenuOpen={() =>
                                                  setOpenSystemMenuIndex(index)
                                                }
                                                setOpenTypeMenuIndex={
                                                  setOpenTypeMenuIndex
                                                }
                                                setOpenContactMenuIndex={
                                                  setOpenContactMenuIndex
                                                }
                                                onMenuClose={() => {
                                                  if (!isAddingNewSystem) {
                                                    setOpenSystemMenuIndex(
                                                      null
                                                    );
                                                  }
                                                }}
                                                menuIsOpen={
                                                  openSystemMenuIndex === index
                                                }
                                                closeMenuOnSelect={
                                                  !isAddingNewSystem
                                                }
                                                components={{
                                                  MenuList:
                                                    CustomSystemMenuList,
                                                }}
                                                hasCreateSystemPermission={
                                                  hasCreateSystemPermission
                                                }
                                                hasCreatePhasePermission={
                                                  hasCreatePhasePermission
                                                }
                                                isSuperAdmin={isSuperAdmin}
                                                isAddingNewSystem={
                                                  isAddingNewSystem
                                                }
                                                setIsAddingNewSystem={
                                                  setIsAddingNewSystem
                                                }
                                                setIsAddingNewContact={
                                                  setIsAddingNewContact
                                                }
                                                setIsAddingNewType={
                                                  setIsAddingNewType
                                                }
                                                newSystemData={newSystemData}
                                                setNewSystemData={
                                                  setNewSystemData
                                                }
                                                newSystemError={newSystemError}
                                                setNewSystemError={
                                                  setNewSystemError
                                                }
                                                isSubmittingNewSystem={
                                                  isSubmittingNewSystem
                                                }
                                                handleSubmitNewSystem={() =>
                                                  handleSubmitNewSystem(
                                                    setFieldValue,
                                                    index,
                                                    values
                                                  )
                                                }
                                                handleCancelNewSystem={
                                                  handleCancelNewSystem
                                                }
                                                placeholder="Select a system..."
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                styles={{
                                                  ...customSelectStyles,
                                                  menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                  }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                  }),
                                                }}
                                              />
                                              <ErrorMessage
                                                name={`systems.${index}.systemId`}
                                                component="div"
                                                className="text-danger small mt-1"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col md={5}>
                                            <Form.Group className="">
                                              <Form.Label>Phases</Form.Label>
                                              <Form.Control
                                                as="textarea"
                                                disabled
                                                rows={3}
                                                value={
                                                  system.systemId
                                                    ? phases
                                                      .filter((phase) =>
                                                        system.phases.includes(
                                                          phase.id
                                                        )
                                                      )
                                                      .reduce(
                                                        (
                                                          acc,
                                                          phase,
                                                          index,
                                                          array
                                                        ) => {
                                                          const separator =
                                                            (index + 1) %
                                                              2 ===
                                                              0
                                                              ? "\n"
                                                              : " | ";
                                                          return (
                                                            acc +
                                                            phase.name +
                                                            (index ===
                                                              array.length - 1
                                                              ? ""
                                                              : separator)
                                                          );
                                                        },
                                                        ""
                                                      )
                                                    : ""
                                                }
                                                placeholder={
                                                  isSubmitSystem[index]
                                                    ? "Loading phases..."
                                                    : !system.systemId
                                                      ? "First select a system"
                                                      : phases.length === 0
                                                        ? "No phases available"
                                                        : "All phases selected"
                                                }
                                                style={{
                                                  resize: "none",
                                                  height: "5rem",
                                                  overflowX: "hidden",
                                                  backgroundColor: "#fff",
                                                  cursor: "not-allowed",
                                                  whiteSpace: "pre-wrap",
                                                }}
                                              />
                                              <ErrorMessage
                                                name={`systems.${index}.phases`}
                                                component="div"
                                                className="text-danger small mt-1"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col
                                            md={1}
                                            className="d-flex align-items-center pt-3 mt-2 mt-md-0"
                                          >
                                            {values.systems.length > 1 && (
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                className="d-flex align-items-end"
                                                onClick={() => {
                                                  const willRemoveActiveSystem =
                                                    values.activeSystemId ===
                                                    system.systemId;
                                                  remove(index);

                                                  setTimeout(() => {
                                                    const updatedSystems =
                                                      values.systems.filter(
                                                        (_, idx) =>
                                                          idx !== index
                                                      );
                                                    const currentSystemExists =
                                                      updatedSystems.some(
                                                        (sys) =>
                                                          sys.systemId ===
                                                          values.activeSystemId
                                                      );

                                                    if (
                                                      !currentSystemExists ||
                                                      willRemoveActiveSystem
                                                    ) {
                                                      const firstSystem =
                                                        updatedSystems.find(
                                                          (sys) =>
                                                            sys.systemId !==
                                                            null
                                                        );
                                                      if (firstSystem) {
                                                        const firstSystemPhases =
                                                          systemPhasesMap[
                                                          firstSystem.systemId
                                                          ] || [];
                                                        setFieldValue(
                                                          "activeSystemId",
                                                          firstSystem.systemId
                                                        );
                                                        setFieldValue(
                                                          "activePhaseId",
                                                          firstSystemPhases?.[0]
                                                            ?.id || null
                                                        );
                                                      } else {
                                                        setFieldValue(
                                                          "activeSystemId",
                                                          null
                                                        );
                                                        setFieldValue(
                                                          "activePhaseId",
                                                          null
                                                        );
                                                      }
                                                    }
                                                  }, 0);
                                                }}
                                                title="Remove system"
                                              >
                                                <RxCross2 size={18} />
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    );
                                  })}

                                  <Row className="px-3 px-md-4">
                                    <Col md={12}>
                                      <Button
                                        type="button"
                                        variant="btn btn-primary"
                                        size="md"
                                        disabled={
                                          areAllSystemsSelected(
                                            values.systems
                                          ) &&
                                          values.systems.some(
                                            (sys) => sys.systemId === null
                                          )
                                        }
                                        onClick={() => {
                                          push({
                                            systemId: null,
                                            phases: [],
                                          });
                                        }}
                                        className="d-flex align-items-center"
                                      >
                                        <FaPlus className="me-2" size={14} />
                                        Add More System
                                      </Button>
                                    </Col>
                                  </Row>
                                  <Row className="mb-3 mt-4 px-3 px-md-4">
                                    <Col md={6}>
                                      <Form.Group className="form-group">
                                        <Form.Label>
                                          Current Active System
                                          <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Select
                                          closeMenuOnScroll={(e) => {
                                            try {
                                              const target = e.target;

                                              if (
                                                !target ||
                                                !target.nodeType ||
                                                typeof target.closest !==
                                                "function"
                                              ) {
                                                return true;
                                              }

                                              const isMenuScroll =
                                                target.closest(
                                                  '[class*="MenuList"]'
                                                ) ||
                                                target.closest(
                                                  '[class*="menu"]'
                                                );

                                              return !isMenuScroll;
                                            } catch (error) {
                                              return true;
                                            }
                                          }}
                                          options={getActiveSystemOptions(
                                            values.systems
                                          )}
                                          value={
                                            values.activeSystemId
                                              ? getActiveSystemOptions(
                                                values.systems
                                              ).find(
                                                (opt) =>
                                                  opt.value ===
                                                  values.activeSystemId
                                              )
                                              : null
                                          }
                                          onChange={(option) => {
                                            const selectedSystemId =
                                              option?.value || null;
                                            setFieldValue(
                                              "activeSystemId",
                                              selectedSystemId
                                            );

                                            const systemExists =
                                              values.systems.some(
                                                (sys) =>
                                                  sys.systemId ===
                                                  selectedSystemId
                                              );

                                            if (
                                              selectedSystemId &&
                                              systemExists
                                            ) {
                                              const selectedSystemPhases =
                                                systemPhasesMap[
                                                selectedSystemId
                                                ] || [];
                                              setFieldValue(
                                                "activePhaseId",
                                                selectedSystemPhases?.[0]?.id ||
                                                null
                                              );
                                            } else {
                                              setFieldValue(
                                                "activePhaseId",
                                                null
                                              );
                                            }
                                          }}
                                          placeholder="Select current active system..."
                                          isSearchable
                                          isClearable
                                          isDisabled={
                                            values.systems.length === 0 ||
                                            !values.systems.some(
                                              (sys) => sys.systemId !== null
                                            )
                                          }
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          styles={{
                                            ...customSelectStyles,
                                            control: (provided, state) => ({
                                              ...customSelectStyles.control(
                                                provided,
                                                state
                                              ),
                                              backgroundColor:
                                                values.systems.length === 0 ||
                                                  !values.systems.some(
                                                    (sys) => sys.systemId !== null
                                                  )
                                                  ? "#f8f9fa"
                                                  : "#fff",
                                            }),
                                          }}
                                        />
                                        <ErrorMessage
                                          name="activeSystemId"
                                          component="div"
                                          className="text-danger small mt-1"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                      <Form.Group className="form-group">
                                        <Form.Label>
                                          Current Active Phase
                                          <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Select
                                          closeMenuOnScroll={(e) => {
                                            try {
                                              const target = e.target;

                                              if (
                                                !target ||
                                                !target.nodeType ||
                                                typeof target.closest !==
                                                "function"
                                              ) {
                                                return true;
                                              }

                                              const isMenuScroll =
                                                target.closest(
                                                  '[class*="MenuList"]'
                                                ) ||
                                                target.closest(
                                                  '[class*="menu"]'
                                                );

                                              return !isMenuScroll;
                                            } catch (error) {
                                              return true;
                                            }
                                          }}
                                          options={getActivePhaseOptions(
                                            values.systems,
                                            values.activeSystemId
                                          )}
                                          value={
                                            values.activePhaseId
                                              ? getActivePhaseOptions(
                                                values.systems,
                                                values.activeSystemId
                                              ).find(
                                                (opt) =>
                                                  opt.value ===
                                                  values.activePhaseId
                                              )
                                              : null
                                          }
                                          onChange={(option) => {
                                            setFieldValue(
                                              "activePhaseId",
                                              option?.value || null
                                            );
                                          }}
                                          placeholder={
                                            !values.activeSystemId
                                              ? "First select active system"
                                              : "Select current active phase..."
                                          }
                                          isSearchable
                                          isClearable
                                          isDisabled={!values.activeSystemId}
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          styles={{
                                            ...customSelectStyles,
                                            control: (provided, state) => ({
                                              ...customSelectStyles.control(
                                                provided,
                                                state
                                              ),
                                              backgroundColor:
                                                !values.activeSystemId
                                                  ? "#f8f9fa"
                                                  : "#fff",
                                            }),
                                          }}
                                        />
                                        <ErrorMessage
                                          name="activePhaseId"
                                          component="div"
                                          className="text-danger small mt-1"
                                        />
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </FieldArray>
                          </Card>

                          <Row>
                            <Form.Label htmlFor="area">Area</Form.Label>
                            <FieldArray
                              name="area"
                              render={(arrayHelpers) => (
                                <>
                                  {values.area.map((are, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <Col
                                          md={6}
                                          className="d-flex flex-row align-items-start "
                                        >
                                          <Col md={10} className="mb-3">
                                            <Form.Control
                                              id={`area.${index}`}
                                              name={`area.${index}`}
                                              value={are}
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                setFieldValue(
                                                  `area.${index}`,
                                                  value
                                                );
                                              }}
                                              onBlur={handleBlur}
                                              placeholder="e.g first floor"
                                            />

                                            <ErrorMessage
                                              name={`area.${index}`}
                                              component="div"
                                              className="text-danger"
                                            />
                                          </Col>

                                          {values.area.length > 1 && (
                                            <Button
                                              variant="danger"
                                              className="d-flex align-items-center justify-content-center ms-2"
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                            >
                                              <RxCross2
                                                style={{
                                                  width: "22px",
                                                  height: "22px",
                                                }}
                                                color="white"
                                              />
                                            </Button>
                                          )}
                                        </Col>
                                      </React.Fragment>
                                    );
                                  })}

                                  <Row className="mb-3">
                                    <Col md={12}>
                                      <Button
                                        type="button"
                                        variant="btn btn-primary"
                                        size="md"
                                        disabled={values.area.length >= 5}
                                        onClick={() => {
                                          arrayHelpers.push("");
                                        }}
                                        className="d-flex align-items-center"
                                      >
                                        <FaPlus className="me-2" size={14} />
                                        Add More Area
                                      </Button>
                                    </Col>
                                  </Row>
                                </>
                              )}
                            />
                          </Row>
                          <FieldArray name="contacts">
                            {({ push, remove }) => {
                              const getAvailableStakeholderTypes = () => {
                                const selectedTypes = values.contacts
                                  .map((stakeholder) => {
                                    const selectedStakeholder =
                                      optionsStakeholder.find(
                                        (option) =>
                                          option.value ===
                                          stakeholder.stakeholderId
                                      );
                                    return selectedStakeholder
                                      ? selectedStakeholder.type
                                      : null;
                                  })
                                  .filter((type) => type !== null);

                                const availableTypes = [
                                  ...new Set(
                                    optionsStakeholder.map(
                                      (option) => option.type
                                    )
                                  ),
                                ].filter(
                                  (type) => !selectedTypes.includes(type)
                                );
                                return availableTypes;
                              };

                              const hasAvailableStakeholders = () => {
                                return (
                                  getAvailableStakeholderTypes().length > 0
                                );
                              };

                              return (
                                <>
                                  <Row className="mb-3 mt-2">
                                    <Col md={12}>
                                      <div className="d-flex justify-content-between align-items-center ">
                                        <h5 className="text-primary mb-0">
                                          Stakeholders
                                        </h5>
                                      </div>
                                    </Col>
                                  </Row>

                                  {values.contacts.map((stakeholder, index) => {
                                    const otherSelectedTypes = values.contacts
                                      .filter((_, i) => i !== index)
                                      .map((stakeholder) => {
                                        const selectedStakeholder =
                                          optionsStakeholder.find(
                                            (option) =>
                                              option.value ===
                                              stakeholder.stakeholderId
                                          );
                                        return selectedStakeholder
                                          ? selectedStakeholder.type
                                          : null;
                                      })
                                      .filter((type) => type !== null);

                                    const currentStakeholderOptions =
                                      optionsStakeholder;

                                    const isStakeholderSelected =
                                      stakeholder.stakeholderId !== null;
                                    const isLoadingContacts =
                                      contactsLoadingMap[index] === true;

                                    return (
                                      <div key={index} className="mb-3">
                                        <Row>
                                          <Col md={4}>
                                            <Form.Label>
                                              Stakeholder
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Select
                                              closeMenuOnScroll={(e) => {
                                                try {
                                                  const target = e.target;

                                                  if (
                                                    !target ||
                                                    !target.nodeType ||
                                                    typeof target.closest !==
                                                    "function"
                                                  ) {
                                                    return true;
                                                  }

                                                  const isMenuScroll =
                                                    target.closest(
                                                      '[class*="MenuList"]'
                                                    ) ||
                                                    target.closest(
                                                      '[class*="menu"]'
                                                    );

                                                  return !isMenuScroll;
                                                } catch (error) {
                                                  return true;
                                                }
                                              }}
                                              name={`contacts.${index}.stakeholderId`}
                                              options={
                                                currentStakeholderOptions
                                              }
                                              value={
                                                stakeholder.stakeholderId
                                                  ? currentStakeholderOptions.find(
                                                    (option) =>
                                                      option.value ===
                                                      stakeholder.stakeholderId
                                                  )
                                                  : null
                                              }
                                              onChange={async (
                                                selectedOption
                                              ) => {
                                                setFieldValue(
                                                  `contacts.${index}.stakeholderId`,
                                                  selectedOption?.value || null
                                                );

                                                setFieldValue(
                                                  `contacts.${index}.type`,
                                                  ""
                                                );
                                                setFieldValue(
                                                  `contacts.${index}.contactId`,
                                                  null
                                                );

                                                if (selectedOption) {
                                                  await getContacts(
                                                    selectedOption.value,
                                                    index
                                                  );
                                                } else {
                                                  setFieldValue(
                                                    `contacts.${index}.contactId`,
                                                    null
                                                  );
                                                }
                                              }}
                                              placeholder="Select Stakeholder"
                                              isClearable
                                              isSearchable
                                              menuPortalTarget={document.body}
                                              menuPlacement="auto"
                                              maxMenuHeight={380}
                                              styles={customSelectStyles}
                                              formatOptionLabel={(option) => (
                                                <div className="d-flex align-items-center">
                                                  <span>{option.label}</span>
                                                </div>
                                              )}
                                            />
                                            <ErrorMessage
                                              name={`contacts.${index}.stakeholderId`}
                                              component="div"
                                              className="text-danger small mt-1"
                                            />
                                            {errors?.contacts?.[index]
                                              ?.stakeholderId && (
                                                <span className="w-100 mt-1 small text-danger">
                                                  {
                                                    errors.contacts[index]
                                                      .stakeholderId
                                                  }
                                                </span>
                                              )}
                                          </Col>
                                          <Col md={3}>
                                            <Form.Group>
                                              <Form.Label>
                                                Type
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </Form.Label>

                                              <Select
                                                closeMenuOnScroll={(e) => {
                                                  try {
                                                    const target = e.target;

                                                    if (
                                                      !target ||
                                                      !target.nodeType ||
                                                      typeof target.closest !==
                                                      "function"
                                                    ) {
                                                      return true;
                                                    }

                                                    const isMenuScroll =
                                                      target.closest(
                                                        '[class*="MenuList"]'
                                                      ) ||
                                                      target.closest(
                                                        '[class*="menu"]'
                                                      );

                                                    return !isMenuScroll;
                                                  } catch (error) {
                                                    return true;
                                                  }
                                                }}
                                                name={`contacts.${index}.type`}
                                                options={getAvailableTypeOptions(
                                                  stakeholder.stakeholderId,
                                                  index,
                                                  values
                                                )}
                                                value={
                                                  stakeholder.type &&
                                                    getAvailableTypeOptions(
                                                      stakeholder.stakeholderId,
                                                      index,
                                                      values
                                                    ).find(
                                                      (option) =>
                                                        option.value ===
                                                        stakeholder.type
                                                    )
                                                    ? getAvailableTypeOptions(
                                                      stakeholder.stakeholderId,
                                                      index,
                                                      values
                                                    ).find(
                                                      (option) =>
                                                        option.value ===
                                                        stakeholder.type
                                                    )
                                                    : null
                                                }
                                                onChange={(selectedOption) => {
                                                  setFieldValue(
                                                    `contacts.${index}.type`,
                                                    selectedOption?.value || ""
                                                  );
                                                  if (
                                                    selectedOption &&
                                                    stakeholder.stakeholderId
                                                  ) {
                                                    const options =
                                                      getContactOptionsForStakeholder(
                                                        stakeholder.stakeholderId
                                                      );
                                                    if (options.length > 0) {
                                                      setTimeout(() => {
                                                        setFieldValue(
                                                          `contacts.${index}.contactId`,
                                                          options[0].value
                                                        );
                                                      }, 0);
                                                    }
                                                  } else {
                                                    setFieldValue(
                                                      `contacts.${index}.contactId`,
                                                      null
                                                    );
                                                  }
                                                }}
                                                onBlur={() =>
                                                  handleBlur({
                                                    target: {
                                                      name: `contacts.${index}.type`,
                                                    },
                                                  })
                                                }
                                                onMenuOpen={() =>
                                                  setOpenTypeMenuIndex(index)
                                                }
                                                onMenuClose={() => {
                                                  if (!isAddingNewType) {
                                                    setOpenTypeMenuIndex(null);
                                                  }
                                                }}
                                                menuIsOpen={
                                                  openTypeMenuIndex === index
                                                }
                                                closeMenuOnSelect={
                                                  !isAddingNewType
                                                }
                                                placeholder={
                                                  isLoadingContacts
                                                    ? "Loading type..."
                                                    : !isStakeholderSelected
                                                      ? "First select stakeholder"
                                                      : "Select type"
                                                }
                                                isClearable
                                                isSearchable
                                                isDisabled={
                                                  !isStakeholderSelected ||
                                                  isLoadingContacts
                                                }
                                                components={{
                                                  MenuList: CustomMenuList,
                                                }}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                isAddingNewType={
                                                  isAddingNewType
                                                }
                                                setIsAddingNewType={
                                                  setIsAddingNewType
                                                }
                                                setIsAddingNewContact={
                                                  setIsAddingNewContact
                                                }
                                                newTypeName={newTypeName}
                                                setNewTypeName={setNewTypeName}
                                                newTypeError={newTypeError}
                                                setNewTypeError={
                                                  setNewTypeError
                                                }
                                                setOpenContactMenuIndex={
                                                  setOpenContactMenuIndex
                                                }
                                                setOpenSystemMenuIndex={
                                                  setOpenSystemMenuIndex
                                                }
                                                newTypeInputRef={
                                                  newTypeInputRef
                                                }
                                                isSubmittingNewType={
                                                  isSubmittingNewType
                                                }
                                                handleSubmitNewType={() =>
                                                  handleSubmitNewType(
                                                    setFieldValue,
                                                    `contacts.${index}.type`
                                                  )
                                                }
                                                handleCancelNewType={
                                                  handleCancelNewType
                                                }
                                                setOpenTypeMenuIndex={
                                                  setOpenTypeMenuIndex
                                                }
                                                styles={{
                                                  menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                  }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                  }),
                                                  control: (
                                                    provided,
                                                    state
                                                  ) => ({
                                                    ...provided,
                                                    color: "#5e667b",
                                                    borderColor:
                                                      errors?.contacts?.[index]
                                                        ?.type ||
                                                        (touched.contacts?.[index]
                                                          ?.type &&
                                                          errorsFormik.contacts?.[
                                                            index
                                                          ]?.type)
                                                        ? "#dc3545"
                                                        : provided.borderColor,
                                                    boxShadow: state.isFocused
                                                      ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                                      : provided.boxShadow,
                                                    "&:hover": {
                                                      borderColor:
                                                        errors?.contacts?.[
                                                          index
                                                        ]?.type ||
                                                          (touched.contacts?.[
                                                            index
                                                          ]?.type &&
                                                            errorsFormik
                                                              .contacts?.[index]
                                                              ?.type)
                                                          ? "#dc3545"
                                                          : "#007bff",
                                                    },
                                                  }),
                                                }}
                                              />
                                              <ErrorMessage
                                                name={`contacts.${index}.type`}
                                                component="div"
                                                className="text-danger small mt-1"
                                              />
                                              {errors?.contacts?.[index]
                                                ?.type && (
                                                  <span className="w-100 mt-1 small text-danger">
                                                    {errors.contacts[index].type}
                                                  </span>
                                                )}
                                            </Form.Group>
                                          </Col>
                                          <Col md={4}>
                                            <Form.Label>
                                              Stakeholder Contact
                                            </Form.Label>

                                            <Select
                                              closeMenuOnScroll={(e) => {
                                                try {
                                                  const target = e.target;

                                                  if (
                                                    !target ||
                                                    !target.nodeType ||
                                                    typeof target.closest !==
                                                    "function"
                                                  ) {
                                                    return true;
                                                  }

                                                  const isMenuScroll =
                                                    target.closest(
                                                      '[class*="MenuList"]'
                                                    ) ||
                                                    target.closest(
                                                      '[class*="menu"]'
                                                    );

                                                  return !isMenuScroll;
                                                } catch (error) {
                                                  return true;
                                                }
                                              }}
                                              name={`contacts.${index}.contactId`}
                                              options={getContactOptionsForStakeholder(
                                                stakeholder.stakeholderId
                                              )}
                                              value={
                                                stakeholder.contactId &&
                                                  getContactOptionsForStakeholder(
                                                    stakeholder.stakeholderId
                                                  ).length > 0
                                                  ? getContactOptionsForStakeholder(
                                                    stakeholder.stakeholderId
                                                  ).find(
                                                    (option) =>
                                                      option.value ===
                                                      stakeholder.contactId
                                                  )
                                                  : null
                                              }
                                              onChange={(selectedOption) => {
                                                setFieldValue(
                                                  `contacts.${index}.contactId`,
                                                  selectedOption?.value || null
                                                );
                                              }}
                                              placeholder={
                                                isLoadingContacts
                                                  ? "Loading contacts..."
                                                  : !isStakeholderSelected
                                                    ? "First select stakeholder"
                                                    : !stakeholder.type
                                                      ? "First select type"
                                                      : contactsLoading
                                                        ? "Loading contacts..."
                                                        : getContactOptionsForStakeholder(
                                                          stakeholder.stakeholderId
                                                        ).length === 0
                                                          ? "No contacts found"
                                                          : "Select Contact"
                                              }
                                              isDisabled={
                                                !isStakeholderSelected ||
                                                !stakeholder.type ||
                                                isLoadingContacts
                                              }
                                              isClearable
                                              isSearchable
                                              menuPortalTarget={document.body}
                                              menuPlacement={
                                                isAddingNewContact
                                                  ? "auto"
                                                  : "auto"
                                              }
                                              onMenuOpen={() =>
                                                setOpenContactMenuIndex(index)
                                              }
                                              setOpenTypeMenuIndex={
                                                setOpenTypeMenuIndex
                                              }
                                              setOpenSystemMenuIndex={
                                                setOpenSystemMenuIndex
                                              }
                                              maxMenuHeight={
                                                isAddingNewContact ? 500 : 380
                                              }
                                              onMenuClose={() => {
                                                if (!isAddingNewContact) {
                                                  setOpenContactMenuIndex(null);
                                                }
                                              }}
                                              menuIsOpen={
                                                openContactMenuIndex === index
                                              }
                                              closeMenuOnSelect={
                                                !isAddingNewContact
                                              }
                                              components={{
                                                MenuList: CustomContactMenuList,
                                              }}
                                              hasCreateStakeholderPermission={
                                                hasCreateStakeholderPermission
                                              }
                                              displayButton={
                                                getContactOptionsForStakeholder(
                                                  stakeholder.stakeholderId
                                                ).length < 10
                                              }
                                              isSuperAdmin={isSuperAdmin}
                                              formatOptionLabel={(option) => (
                                                <div>
                                                  <div className="">
                                                    {option.label}
                                                  </div>

                                                  <small className="">
                                                    {option.phone}{" "}
                                                    {option?.email &&
                                                      " - " + option?.email}
                                                  </small>
                                                </div>
                                              )}
                                              isAddingNewContact={
                                                isAddingNewContact
                                              }
                                              setIsAddingNewContact={
                                                setIsAddingNewContact
                                              }
                                              setIsAddingNewType={
                                                setIsAddingNewType
                                              }
                                              newContactData={newContactData}
                                              setNewContactData={
                                                setNewContactData
                                              }
                                              newContactError={newContactError}
                                              setNewContactError={
                                                setNewContactError
                                              }
                                              isSubmittingNewContact={
                                                isSubmittingNewContact
                                              }
                                              handleSubmitNewContact={() =>
                                                handleSubmitNewContact(
                                                  setFieldValue,
                                                  index,
                                                  stakeholder.stakeholderId
                                                )
                                              }
                                              handleCancelNewContact={
                                                handleCancelNewContact
                                              }
                                              styles={{
                                                ...customSelectStyles,
                                                control: (provided, state) => ({
                                                  ...customSelectStyles.control(
                                                    provided,
                                                    state
                                                  ),
                                                  backgroundColor:
                                                    isStakeholderSelected
                                                      ? "#fff"
                                                      : "#f8f9fa",
                                                  cursor: isStakeholderSelected
                                                    ? "pointer"
                                                    : "not-allowed",
                                                }),
                                                menuPortal: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9999,
                                                }),
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9999,
                                                }),
                                              }}
                                            />
                                            <ErrorMessage
                                              name={`contacts.${index}.contactId`}
                                              component="div"
                                              className="text-danger small mt-1"
                                            />
                                            {errors?.contacts?.[index]
                                              ?.contactId && (
                                                <span className="w-100 mt-1 small text-danger">
                                                  {
                                                    errors.contacts[index]
                                                      .contactId
                                                  }
                                                </span>
                                              )}
                                          </Col>

                                          <Col
                                            md={1}
                                            className="d-flex align-items-end pb-2"
                                          >
                                            {values.contacts.length > 1 && (
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                className="d-flex align-items-center"
                                                onClick={() => remove(index)}
                                                title="Remove stakeholder"
                                              >
                                                <RxCross2 size={18} />
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    );
                                  })}

                                  <Row className="mb-3">
                                    <Col md={12}>
                                      <Button
                                        type="button"
                                        variant="btn btn-primary"
                                        size="md"
                                        onClick={() => {
                                          push({
                                            stakeholderId: null,
                                            contactId: null,
                                            type: "",
                                          });
                                        }}
                                        className="d-flex align-items-center"
                                      >
                                        <FaPlus className="me-2" size={14} />
                                        Add More Stakeholder
                                      </Button>
                                    </Col>
                                  </Row>
                                </>
                              );
                            }}
                          </FieldArray>

                          <div className="d-flex flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2">
                            <Button
                              type="button"
                              className="me-2 me-md-5 px-3 px-md-4"
                              variant="btn btn-light"
                              onClick={() => {
                                setFieldValue("name", "");
                                setFieldValue("location", "");
                                setFieldValue("estimate", "");
                                setFieldValue(
                                  "bidDate",
                                  new Date().toISOString().slice(0, 10)
                                );
                                setFieldValue("siteName", "");
                                setFieldValue("contacts", [
                                  { stakeholderId: null, contactId: null },
                                ]);
                                setFieldValue("systems", [
                                  { systemId: null, phases: [] },
                                ]);
                                setFieldValue("activeSystemId", null);
                                setFieldValue("activePhaseId", null);
                                setFieldValue("area", [""]);

                                setSystemPhasesMap({});
                                setContacts([]);
                                setSelectKey((prev) => prev + 1);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              type="submit"
                              disabled={isSubmitting}
                              variant="btn btn-primary"
                              className="me-2 me-md-5 px-3 px-md-4"
                            >
                              Submit
                            </Button>
                            <Button
                              type="button"
                              className=" px-3 px-md-4"
                              variant="btn btn-danger"
                              onClick={() =>
                                navigate("/dashboard/app/job-list")
                              }
                            >
                              Cancel
                            </Button>
                          </div>
                        </>
                      ) : (
                        loader && <FadeLoaderComponent />
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default JobAdd;
